class RitualSlider {
    constructor() {
        this.init();
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.initializeSliders();
            this.setupVideoControls();
        });
    }

    initializeSliders() {
        const sliders = document.querySelectorAll('[component-ritual-slider]');
        sliders.forEach(slider => {
            new Splide(slider, {
                type: 'slide',
                perPage: 3,
                perMove: 1,
                autoplay: false,
                arrows: false,
                pagination: false,
                breakpoints: {
                    768: {
                        perPage: 1,
                        gap: '24px',
                    },
                    1240: {
                       perPage: 2,
                       gap: '24px',
                    }
                },
            }).mount();
        });
    }

    setupVideoControls() {
        const videos = document.querySelectorAll('.component-ritual-slider-container video');

        videos.forEach(video => {
            const playButton = video.closest('.splide__slide').querySelector('#play-button');
            const thumbnail_image = video.closest('.video-container').querySelector('.thumbnail_video');

            video.addEventListener('click', () => this.toggleVideo(video, playButton));
            playButton.addEventListener('click', () => this.toggleVideo(video, playButton));

            video.addEventListener('play', () => {
                playButton.style.display = 'none';
                thumbnail_image.style.display = 'none';
            });

            video.addEventListener('pause', () => {
                playButton.style.display = 'block';
            });
        });
    }

    toggleVideo(video, playButton) {
        const allVideos = document.querySelectorAll('.component-ritual-slider-container video');

        if (video.paused) {
            allVideos.forEach(v => {
                v.pause();
                const button = v.closest('.splide__slide').querySelector('#play-button');
                button.style.display = 'block';
            });
            video.play();
            video.muted = false;
            playButton.style.display = 'none';
        } else {
            video.pause();
            video.muted = true;
            playButton.style.display = 'block';
        }
    }
}

new RitualSlider();
